module.exports = vendor_f9417cdb68f8b2c1d550;